import { FailedReason } from '../constants';
import { DataResidency, DataResidencySlim, } from '../hosted-web-content-sdk.interface';
import { AppInitState } from '../hosted-web-content-sdk.interface';
/**
 * Regular expression that matches a UPN
 * eg. user_name@microsoft.com, user_name_12%40microsoft.domain.com
 */
var upnRegExp = new RegExp('[a-zA-Z0-9_\\-\\.]+(@|%40|%2540)[a-zA-Z0-9_\\-\\.]+\\.[a-zA-Z]{2,5}', 'g');
/**
 * String to replace matched UPNs with.
 */
var maskedUpn = 'email_removed';
/**
 * The valid URL origin for LegacyLinkHandlers
 */
export var validLegacyLinkOrigin = 'https://teams.microsoft.com';
export var getPageDisplayNameFromAppDefinition = function (appDefinition, entityId) {
    var _a, _b;
    var tab = (_b = (_a = appDefinition.pages) === null || _a === void 0 ? void 0 : _a.static) === null || _b === void 0 ? void 0 : _b.find(function (s) { return s.entityId === entityId; });
    return tab === null || tab === void 0 ? void 0 : tab.name;
};
export var isLoadOrBeforeUnload = function (key) {
    return key === 'load' || key === 'beforeUnload';
};
export var isUserSettingsChange = function (key) { return key === 'userSettingsChange'; };
export var getStateToSave = function (registrationType, settingTypes) {
    var _a;
    return isUserSettingsChange(registrationType)
        ? { userSettingsChange: { userSettingTypes: settingTypes } }
        : (_a = {},
            _a["".concat(registrationType)] = true,
            _a);
};
/**
 * @param appInitInfo App init info of the rendered app
 * @param appDefinition App definition of the rendered app
 * @returns True for failed state and showTabLoading:true and also for App initialization timeout for showTabLoading:false as well
 */
export var shouldShowHubErrorUi = function (appInitInfo, appDefinition) {
    return appInitInfo.state === AppInitState.Failed &&
        (appDefinition.showLoadingIndicator ||
            (!appDefinition.showLoadingIndicator && appInitInfo.reason === FailedReason.AppInitTimeout));
};
/**
 * AppContext Type Guard
 *
 * @returns true if provided appContext is of type AppContext, false otherwise.
 */
export var isFullAppContext = function (appContext) {
    return appContext ? appContext.user.id !== undefined : false;
};
var minimumSupportedAdaptiveCardSchema = { majorVersion: 1, minorVersion: 5 };
export function getMinimumAdaptiveCardSchemaVersionAsString() {
    return "".concat(minimumSupportedAdaptiveCardSchema.majorVersion, ".").concat(minimumSupportedAdaptiveCardSchema.minorVersion);
}
export function isHostAdaptiveCardSchemaVersionUnsupported(hostAdaptiveCardSchemaVersion) {
    return (hostAdaptiveCardSchemaVersion.majorVersion < minimumSupportedAdaptiveCardSchema.majorVersion ||
        (hostAdaptiveCardSchemaVersion.majorVersion == minimumSupportedAdaptiveCardSchema.majorVersion &&
            hostAdaptiveCardSchemaVersion.minorVersion < minimumSupportedAdaptiveCardSchema.minorVersion));
}
/**
 * Mapping user data residency to values that are exposed to 1st-Party developers
 */
export var mapToDataResidencySlim = function (dataResidency) {
    var mappedResidency;
    if (dataResidency === DataResidency.Public) {
        mappedResidency = DataResidencySlim.Public;
    }
    else if (dataResidency === DataResidency.EUDB) {
        mappedResidency = DataResidencySlim.EUDB;
    }
    else {
        mappedResidency = DataResidencySlim.Other;
    }
    return mappedResidency;
};
/**
 * Checks for Upn's in an input string and replace it with a generic placeholder
 *
 * @export
 * @param {string} input - string to look for UPN in
 * @returns {string} - input string with any UPNs cleaned out
 */
export function replaceUPNs(input) {
    if (input) {
        input = input.replace(upnRegExp, maskedUpn);
    }
    return input;
}
/**
 * Sanitize message before logging
 *
 * @export
 * @param {string} message - message to be sanitized
 * @returns {string} - sanitize message
 */
export function sanitizeMessage(message) {
    if (message) {
        return replaceUPNs(message);
    }
    return '';
}
//# sourceMappingURL=helpers.js.map